import { render, staticRenderFns } from "./province-map-selector.vue?vue&type=template&id=2908d65f&scoped=true"
import script from "./province-map-selector.vue?vue&type=script&lang=js"
export * from "./province-map-selector.vue?vue&type=script&lang=js"
import style0 from "./province-map-selector.vue?vue&type=style&index=0&id=2908d65f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2908d65f",
  null
  
)

export default component.exports